import { FetchType, UpdateType, CollectionFetchType } from "types"

const handleFetchPending = (state: FetchType) => {
  state.fetchStatus.isFetching = true
  state.fetchStatus.isSuccess = false
  state.fetchStatus.isFailed = false
}

const handleFetchRejected = (state: FetchType) => {
  state.fetchStatus.isFetching = false
  state.fetchStatus.isSuccess = false
  state.fetchStatus.isFailed = true
}

const handleFetchFulfilled = (state: FetchType) => {
  state.fetchStatus.isFetching = false
  state.fetchStatus.isSuccess = true
  state.fetchStatus.isFailed = false
}

const handleCollectionFetchPending = (state: CollectionFetchType) => {
  state.fetchCollectionStatus.isFetching = true
  state.fetchCollectionStatus.isSuccess = false
  state.fetchCollectionStatus.isFailed = false
}

const handleCollectionFetchRejected = (state: CollectionFetchType) => {
  state.fetchCollectionStatus.isFetching = false
  state.fetchCollectionStatus.isSuccess = false
  state.fetchCollectionStatus.isFailed = true
}

const handleCollectionFetchFulfilled = (state: CollectionFetchType) => {
  state.fetchCollectionStatus.isFetching = false
  state.fetchCollectionStatus.isSuccess = true
  state.fetchCollectionStatus.isFailed = false
}

const handleUpdatePending = (state: UpdateType) => {
  state.updateStatus.isProgress = true
}

const handleUpdateRejected = (state: UpdateType) => {
  state.updateStatus.isProgress = false
  state.updateStatus.isSuccess = false
  state.updateStatus.isFailed = true
}

export {
  handleFetchPending,
  handleFetchRejected,
  handleFetchFulfilled,
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
  handleUpdatePending,
  handleUpdateRejected,
}
